import { generatePath } from 'react-resource-router-next';

export const WORKSPACE_PREFIX = '/w/:workspaceId';
export const SPACE_PREFIX = '/spaces/:spaceId';
export const SITE_PREFIX = '/s/:cloudId';

/**
 * Generate a path for a studio app route with workspace ID. V2 ONLY.
 * @param subPath - The sub-path of the route (everything after the workspace prefix `/w/:workspaceId`).
 * @param workspaceId - The workspace ID.
 * @param params - The parameters to pass to the route apart from the workspace ID.
 * @returns The generated path.
 */
export const generateWorkspacePath = (
	subPath: string,
	workspaceId: string,
	params: { [key: string]: string | number | boolean | void | null } = {},
): string => {
	return generatePath(getWorkspacePath(subPath), {
		...params,
		workspaceId,
	});
};

/**
 * Get the path pattern for a studio app route. Used for both V1 and V2 routes.
 * @param subPath - The sub-path of the route (everything after the workspace prefix `/w/:workspaceId`).
 * @returns The path pattern.
 */
export const getWorkspacePath = (
	subPath: string = '',
	opts: {
		appendSpacePrefix?: boolean;
	} = {},
) => `${WORKSPACE_PREFIX}${!!opts.appendSpacePrefix ? SPACE_PREFIX : ''}${subPath}`;
